/*
 * @Description: 导入设置
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */

export default {
  导入设置: '导入设置',
  名称: '名称',
  类型: '类型',
  文件名称: '文件名称',
  请输入文件名称: '请输入文件名称',
  提示文本: '提示文本',
  请输入提示文本: '请输入提示文本',
  资源库: '资源库',
  请输入搜索内容: '请输入搜索内容',
  关联对象: '关联对象',
  请选择关联对象: '请选择关联对象',
  请选择关联主键: '请选择关联主键',
  关联主键: '关联主键',
  系统字段: '系统字段',
  是否必填: '是否必填',
  '请补充基本信息！': '请补充基本信息！',
  '该对象已关联，不能重复关联！': '该对象已关联，不能重复关联！'
};
